export default __webpack_public_path__ + "static/Graphik-Medium-Web-2f70874429d4ed71a78b2166795f51bd.woff";